let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dg10h")).then(() => parcelRequire('etJR3'));